import { Injectable } from '@angular/core';
import { AuthenticationService } from './authentication.service';
import { Permissoes } from './permissoes';


@Injectable({
	providedIn: 'root'
})
export class PermissoesService {

	constructor(private auth: AuthenticationService) { }

	validarPermissaoRota(rota) {
		if (this.rotaPerfilDeAcessoLiberadaParaUsusarioAdministrador(rota)) {
			return;
		}

		if (!this.auth.usuarioTemPermissaoNaRota(rota)) {
			throw new Error('Usuário sem permissão para acessar.');
		}
	}

	private rotaPerfilDeAcessoLiberadaParaUsusarioAdministrador(rota: any): boolean {
		return ((this.eCadastroPerfilDeAcesso(rota) || this.eCadastroDeUsuario(rota)) && this.auth.usuarioAdministrador());
	}

	private eCadastroPerfilDeAcesso(rota: any) {
		const rotaPesquisaPerfilAcesso = Permissoes.PESQUISA_PERFIL_ACESSO.getValor();
		const rotaCadastroPerfilAcesso = Permissoes.CADASTRO_PERFIL_ACESSO.getValor();
		return (rota === rotaPesquisaPerfilAcesso || rota === rotaCadastroPerfilAcesso);
	}

	private eCadastroDeUsuario(rota: any) {
		const rotaCadastroUsuario = Permissoes.CADASTRO_USUARIO.getValor();
		const rotaPesquisaDeUsuario = Permissoes.PESQUISA_USUARIO.getValor();
		return (rota === rotaCadastroUsuario || rota === rotaPesquisaDeUsuario);
	}
}
